var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyundaiIconoVerMas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19250",
    "data-name": "Group 19250",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #002e6b;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #002e6b;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 29,
    cy: 29,
    r: 29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 29,
    cy: 29,
    r: 28
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19249",
    "data-name": "Group 19249",
    transform: "translate(19.001 19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18724",
    "data-name": "Rectangle 18724",
    className: "cls-2",
    width: 1.94,
    height: 12.933,
    rx: 0.97,
    transform: "translate(18.713 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18725",
    "data-name": "Rectangle 18725",
    className: "cls-2",
    width: 1.94,
    height: 12.933,
    rx: 0.97,
    transform: "translate(20.653) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18726",
    "data-name": "Rectangle 18726",
    className: "cls-2",
    width: 2,
    height: 26,
    rx: 1,
    transform: "translate(18.385 0.854) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyundaiIconoVerMas);
export default __webpack_public_path__ + "static/media/hyundai-icono-ver-mas.82860740f83d1a3a383fc4bba79e4f1a.svg";
export { ForwardRef as ReactComponent };